module.exports = __webpack_public_path__ + "img/benjamin-zubovic.1cc831b9.jpg";